export const REQUEST_UTM_STUDENT_FILTERS = 'UTM_STUDENT_FILTERS';
export const REQUEST_UTM_STUDENT_FILTERS_SUCCEEDED = 'UTM_STUDENT_FILTERS_SUCCEEDED';
export const REQUEST_UTM_STUDENT_FILTERS_FAILED = 'UTM_STUDENT_FILTERS_FAILED';
